import { render, staticRenderFns } from "./UsuarioInstitucionalAdmin.vue?vue&type=template&id=93f21a32"
import script from "./UsuarioInstitucionalAdmin.vue?vue&type=script&lang=js"
export * from "./UsuarioInstitucionalAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports